import {
	GET_PRICE_CALENDAR_REQUEST,
	GET_PRICE_CALENDAR_SUCCESS,
	GET_PRICE_CALENDAR_ERROR,
	SET_PRICE_CALENDAR_GO_INTENT,
	SET_PRICE_CALENDAR_BACK_INTENT,
	TOGGLE_PRICE_CALENDAR_MINIMAP,
	TOGGLE_PRICE_CALENDAR_TRIP_TYPE,
	PRICE_CALENDAR_RESET
} from "./constants";

import { getPriceRange, getDefaultGoIntent, getDefaultBackIntent } from "./Main";

const winWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
const getMinimapDefaultState = winWidth => winWidth < 768;

export const INITIAL_STATE = {
	fetching: false,
	from: "",
	to: "",
	searchIntents: null,
	error: null,
	goIntent: null,
	backIntent: null,
	showMinimap: getMinimapDefaultState(winWidth)
};

let priceRange, goIntent, showMinimap;

const priceCalendarReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case GET_PRICE_CALENDAR_REQUEST:
			return {
				...state,
				fetching: true,
				origin: action.from,
				destination: action.to,
				error: null
			};

		case GET_PRICE_CALENDAR_SUCCESS:
			priceRange = getPriceRange(action.searchIntents, state.tripType === "RT");
			goIntent = action.goIntent ? action.goIntent : null;
			showMinimap = state.hasOwnProperty("showMinimap")
				? state.showMinimap
				: getMinimapDefaultState(winWidth);

			return {
				...state,
				searchIntents: action.searchIntents,
				priceRange,
				fetching: false,
				showMinimap,
				goIntent: goIntent || (state.tripType === "RT" ? null : getDefaultGoIntent())
			};

		case GET_PRICE_CALENDAR_ERROR:
			return {
				...state,
				error: action.error,
				searchIntents: null,
				priceRange: null,
				fetching: false
			};

		case SET_PRICE_CALENDAR_GO_INTENT:
			return {
				...state,
				goIntent: action.goIntent,
				backIntent: null,
				interacted: true
			};

		case SET_PRICE_CALENDAR_BACK_INTENT:
			return {
				...state,
				backIntent: action.backIntent
			};

		case TOGGLE_PRICE_CALENDAR_MINIMAP:
			return {
				...state,
				showMinimap: action.show
			};

		case TOGGLE_PRICE_CALENDAR_TRIP_TYPE:
			const nextTripType = action.tripType || (state.tripType === "OW" ? "RT" : "OW");
			const nextGoIntent = state.goIntent || getDefaultGoIntent();
			return {
				...state,
				tripType: nextTripType,
				goIntent: nextGoIntent,
				backIntent: null
			};

		case PRICE_CALENDAR_RESET:
			return {
				...state,
				goIntent: null,
				backIntent: null
			};

		default:
			return state;
	}
};

export default priceCalendarReducer;
